import clsx from 'clsx';
import { Button, Stack, Text } from 'components';
import { expandAiScribeDrawer } from 'store/aiScribe/aiScribeSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useEffect, useRef } from 'react';

import { formatDuration, PauseIcon, MicrophoneIcon } from '../expanded/expanded';
import { useAiScribeContext } from '../../context/useAiScribe';
import style from './collapsed.module.scss';

const CollapsedDrawer = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { clientName, duration, isPaused, error } = useAppSelector((s) => s.aiScribe);
  const dispatch = useAppDispatch();

  const { pauseRecording, resumeRecording } = useAiScribeContext();

  const handlePauseResume = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent drawer from expanding when clicking pause/resume
    if (isPaused) {
      resumeRecording();
    } else {
      pauseRecording();
    }
  };

  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.width = `${window.innerWidth - 105}px`;
    }
  }, []);

  return (
    <Stack
      ref={wrapperRef}
      onClick={() => dispatch(expandAiScribeDrawer())}
      position="fixed"
      bottom={8}
      left={0}
      ml="16px"
      px="16px"
      display="flex"
      flexDirection="row"
      alignItems="center"
      height="72px"
      width="100%"
      bgcolor="white"
      borderRadius="64px"
      boxShadow="0 2px 1px 0 rgba(0, 0, 0, 0.03), 0 -8px 40px 0 rgba(13, 28, 48, 0.08)"
      zIndex={1000}
      boxSizing="border-box"
    >
      <Stack
        width="100%"
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap="12px"
        justifyContent="space-between"
        minWidth="0px"
        boxSizing="border-box"
      >
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="12px"
          overflow="hidden"
          flexGrow={1}
          boxSizing="border-box"
        >
          <Button
            icon={isPaused ? <MicrophoneIcon /> : <PauseIcon />}
            theme={isPaused ? 'green' : 'warning'}
            shape="circle"
            handleOnClick={handlePauseResume}
          />
          <Text
            size="large"
            weight="semibold"
            style={{
              overflow: 'hidden',
              minWidth: '0px',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {clientName}
          </Text>
        </Stack>
        <Stack display="flex" flexDirection="row" alignItems="center" gap="8px">
          {error && <span className={clsx('material-icons', style.errorIcon)}>error_outline</span>}
          <div className={style.duration}>{formatDuration(duration)}</div>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CollapsedDrawer;
